import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { DriversState } from '../../types';

import { getDriverLocations } from '../operations/getDriverLocations';

import { STATUS_LOADING } from 'common/constants';

export const setDriverLocations = (builder: ActionReducerMapBuilder<DriversState>) => builder
  .addCase(getDriverLocations.pending, (state) => {
    state.locations.loadingStatus = STATUS_LOADING.load;
  })
  .addCase(getDriverLocations.fulfilled, (state, { payload }) => {
    state.locations.loadingStatus = STATUS_LOADING.done;
    state.locations.data = payload.usersLocations;
  })
  .addCase(getDriverLocations.rejected, (state) => {
    state.locations.loadingStatus = STATUS_LOADING.error;
  });